var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBClockStopwatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-clock-stopwatch",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.995,4.079c6.753,0.008 11.329,6.967 8.719,13.147c-2.44,5.777 -9.865,7.641 -14.74,3.619c-3.25,-2.682 -4.292,-7.217 -2.7,-10.986c1.42,-3.361 4.833,-5.78 8.721,-5.78Zm-0.001,16.902c5.618,-0.007 9.204,-6.077 6.54,-10.984c-2.8,-5.159 -10.28,-5.159 -13.08,0c-2.664,4.908 0.918,10.984 6.54,10.984Zm4.115,-10.111l-3.399,3.389c-0.387,0.386 -1.045,0.386 -1.432,-0.001c-0.387,-0.387 -0.387,-1.044 -0,-1.432l3.399,-3.388c0.387,-0.387 1.045,-0.387 1.432,-0c0.387,0.387 0.388,1.045 0,1.432Zm-6.42,-9.864l4.61,-0c0.547,-0 1.013,0.465 1.013,1.013c-0,0.547 -0.466,1.012 -1.013,1.012l-4.61,0c-0.547,0 -1.012,-0.465 -1.012,-1.012c-0,-0.548 0.465,-1.013 1.012,-1.013Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBClockStopwatch);
export default __webpack_public_path__ + "static/media/iconB-clock-stopwatch.568de8b193eb57f8ee840ded3cdfb573.svg";
export { ForwardRef as ReactComponent };